const mortgageBankerPage = (function mortgageBankerPageModule() {
    const contactFormId = 'mortgage-banker-contact-form';

    function handleContactLinkClick(event) {
        if (!(event.target instanceof Element)) {
            return;
        }

           const link = event.target.closest('[data-mortgage-banker-contact-link]');
           const contactForm = document.getElementById(contactFormId);
            const form = contactForm?.querySelector('form');

            if (!link || !contactForm || !form) {
                return;
            }

        event.preventDefault();
        window.history.replaceState(null, '', `#${contactFormId}`);
        contactForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function init() {
        document.addEventListener('click', handleContactLinkClick);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

export { mortgageBankerPage };
